import Button from "@/components/ui/button"
import CustomInput from "@/components/ui/input"
import useNotification from "@/hooks/use-notification"
import { authApi } from "../services/auth.api"
import { validatePasswordForm } from "../utils/password.utils"
import { t } from "i18next"
import React, { useState } from "react"
import styles from "../styles/login.module.scss"
import Lock from "@/components/icons/lock"

interface CreateNewPasswordProps {
  onSuccess: () => void
  email: string
  otpCode: string
}

const CreateNewPassword: React.FC<CreateNewPasswordProps> = ({ onSuccess, email, otpCode }) => {
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const { notifyError, notifySuccess } = useNotification()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const validation = validatePasswordForm(password, confirmPassword)
    if (!validation.isValid) {
      notifyError(t(validation.error || "login.passwordResetError"))
      return
    }

    if (!email || !otpCode) {
      notifyError(t("login.invalidResetData"))
      return
    }

    setIsLoading(true)

    try {
      await authApi.resetPassword({
        email,
        code: otpCode,
        password,
        passwordConfirm: confirmPassword,
      })

      notifySuccess(t("login.passwordResetSuccess"))
      onSuccess()
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || t("login.passwordResetError")
      notifyError(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className={styles["create-new-password"]}>
      <div className={styles["create-new-password-header"]}>
        <h2>{t("login.createNewPasswordTitle")}</h2>
        <p>{t("login.createNewPasswordDescription")}</p>
      </div>

            <form onSubmit={handleSubmit} className={styles["create-new-password-form"]}>
      <CustomInput
        label={t("login.newPassword")}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
        placeholder={t("login.newPasswordPlaceholder")}
        type="password"
        startIcon={<Lock width={24} height={24} />}
        value={password}
      />

      <CustomInput
        label={t("login.confirmPassword")}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
        placeholder={t("login.confirmPasswordPlaceholder")}
        type="password"
        startIcon={<Lock width={24} height={24} />}
        value={confirmPassword}
      />

      <Button
        color="primary"
        size="medium"
        type="submit"
        variant="contained"
        disabled={isLoading}
      >
        {isLoading ? t("common.loading") : t("login.createPassword")}
      </Button>
            </form>
        </div>
    )
}

export default CreateNewPassword

